import { TrackerApiConfig } from './config'

export const trackingScript = (accId: string, assId: string, domain?: string) => {
	const domainForScripts = domain || TrackerApiConfig.API_BASE_URL
	return `<script defer type="application/javascript" src="${domainForScripts}/s/${accId}/${assId}"></script>`
}
export const conversionScript = (domain?: string) => {
	const domainForScripts = domain || TrackerApiConfig.API_BASE_URL
	return `<script defer type="application/javascript" src="${domainForScripts}/sc"></script>`
}

export const conversionCode = () => {
	return `// simple conversion
CG.conversion()
	`
}

export const conversionCodeWithMessage = () => {
	return `// with message
	CG.conversion('Sample conversion message')
	`
}

export const conversionCodeWithMessageAndValue = () => {
	return `// with message and value 
	CG.conversion('Sample conversion message', 149)
	`
}
